import { gql, MutationHookOptions, useMutation } from '@apollo/client';

import { InputBatchBillingServiceContractsSettings } from '@work4all/models/lib/Classes/InputBatchBillingServiceContractsSettings.entity';
import { WartungsvertragPamentMethodSource } from '@work4all/models/lib/Enums/WartungsvertragPamentMethodSource.enum';

const UPSERT_BATCH_BILLING_SERVICE_CONTRACTS_SETTINGS = gql`
  mutation UpsertBatchBillingServiceContractsSettings(
    $settings: InputBatchBillingServiceContractsSettings!
  ) {
    upsertBatchBillingServiceContractsSettings(settings: $settings) {
      batchBillingRunName
      considerQuantity
      divideByRhythm
      dividePriceByQuantity
      headerShowBatchBillingRunName
      headerShowContractNumber
      headerShowObjectName
      headerShowPeriod
      internalNoteShowBatchBillingRunName
      internalNoteShowContractNumber
      internalNoteShowObjectName
      internalNoteShowPeriod
      multiplyWithRhythm
      paymentTypeSource
      purchasePriceFromArticle
      setNewBillingDate
      useDefaultTextFromCustomer
      headerShowContractTypeAlias
      internalNoteShowContractTypeAlias
    }
  }
`;

export interface UpsertBatchBillingServiceContractsSettingsMutationResponse {
  batchBillingServiceContracts: {
    batchBillingRunName?: string | null;
    headerShowBatchBillingRunName?: boolean;
    headerShowObjectName?: boolean;
    headerShowPeriod?: boolean;
    headerShowContractNumber?: boolean;
    internalNoteShowBatchBillingRunName?: boolean;
    internalNoteShowObjectName?: boolean;
    internalNoteShowPeriod?: boolean;
    internalNoteShowContractNumber?: boolean;
    useDefaultTextFromCustomer?: boolean;
    paymentTypeSource?: WartungsvertragPamentMethodSource;
    setNewBillingDate?: boolean;
    considerQuantity?: boolean;
    dividePriceByQuantity?: boolean;
    divideByRhythm?: boolean;
    multiplyWithRhythm?: boolean;
    purchasePriceFromArticle?: boolean;
    headerShowContractTypeAlias?: boolean;
    internalNoteShowContractTypeAlias?: boolean;
  };
}

export interface UpsertBatchBillingServiceContractsSettingsMutationVariables {
  settings: InputBatchBillingServiceContractsSettings;
}

export function useUpsertBatchBillingServiceContractsSettingsMutation(
  options?: MutationHookOptions<
    UpsertBatchBillingServiceContractsSettingsMutationResponse,
    UpsertBatchBillingServiceContractsSettingsMutationVariables
  >
) {
  return useMutation<
    UpsertBatchBillingServiceContractsSettingsMutationResponse,
    UpsertBatchBillingServiceContractsSettingsMutationVariables
  >(UPSERT_BATCH_BILLING_SERVICE_CONTRACTS_SETTINGS, options);
}
